import React, { useState } from 'react';
import { useUserSearch } from '../../../hooks/useUserSearch';
import styles from './PrintDocsPage.module.css';
import commonStyles from '../../common/CommonStyles.module.css';

const PrintDocsPage = () => {
  const [selectedDoc, setSelectedDoc] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  const {
    searchQuery,
    searchResults,
    isSearching,
    handleSearchChange,
    handleUserSelect,
    selectedUserId,
    setSelectedUserId
  } = useUserSearch();

  const handleDownload = async () => {
    if (!selectedDoc || !selectedUserId) {
      setError('Пожалуйста, выберите документ и выберите пионера');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const response = await fetch(`/api/forms/${selectedDoc}/${selectedUserId}`, {
        method: 'POST',
      });

      if (!response.ok) throw new Error('Ошибка генерации документа');

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${selectedDoc}_${selectedUserId}.docx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Ошибка:', error);
      setError(error.message || 'Ошибка при загрузке документа');
    } finally {
      setLoading(false);
    }
  };

  const handleSelectUser = (user) => {
    handleUserSelect(user);
    setSelectedUser(user);
  };

  const documents = [
    { id: 'application', name: 'Заявление' },
    { id: 'questionnaire', name: 'Анкета' },
  ];

  return (
      <div className={commonStyles.pageContainer}>
        <div className={styles.contentWrapper}>
          <h2 className={styles.title}>Печать документов</h2>

          <div className={styles.printForm}>
            <div className={styles.formSection}>
              <label className={styles.label}>Выберите документ:</label>
              <select
                  className={styles.select}
                  value={selectedDoc}
                  onChange={(e) => setSelectedDoc(e.target.value)}
              >
                <option value="">Выберите тип документа</option>
                {documents.map((doc) => (
                    <option key={doc.id} value={doc.id}>
                      {doc.name}
                    </option>
                ))}
              </select>
            </div>

            <div className={styles.formSection}>
              <label className={styles.label}>Выберите комсомольца:</label>
              <div className={styles.searchContainer}>
                <input
                    type="text"
                    className={styles.input}
                    value={searchQuery}
                    onChange={handleSearchChange}
                    placeholder="Поиск по ФИО..."
                />

                {isSearching && <div className={styles.searchLoading}>Поиск...</div>}

                {searchResults.length > 0 && (
                    <div className={styles.searchResults}>
                      {searchResults.map(user => (
                          <div
                              key={user.id}
                              className={styles.searchResultItem}
                              onClick={() => handleSelectUser(user)}
                          >
                            {user.firstName} {user.lastName} ({user.email})
                          </div>
                      ))}
                    </div>
                )}
              </div>

              {selectedUser && (
                  <div className={styles.selectedUser}>
                    Выбран: {selectedUser.firstName} {selectedUser.lastName}
                  </div>
              )}
            </div>

            {error && <div className={styles.error}>{error}</div>}

            <button
                className={styles.printButton}
                onClick={handleDownload}
                disabled={loading || !selectedDoc || !selectedUserId}
            >
              {loading ? 'Идет загрузка...' : 'Скачать документ'}
            </button>
          </div>
        </div>
      </div>
  );
};

export default PrintDocsPage;